import angular = require("angular"); 
import { directivesModule } from "../directivesModule";

class PhoneSplashDirective implements angular.IDirective {
	public restrict: string = "AE";
	public templateUrl:string= '/Common/Layout/_phoneSplashScreenTemplate.html';
	public replace: boolean = true;
}

directivesModule.directive("bvPhoneSplash", [() => new PhoneSplashDirective()]);



// WEBPACK FOOTER //
// ./Common/Layout/PhoneSplashScreenDirective.ts